var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapaCads2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-101"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-101",
    cx: 245.8,
    cy: 350.74,
    rx: 228.29,
    ry: 126.4,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-101"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-101",
    cx: 266.08,
    cy: 383.86,
    rx: 76.37,
    ry: 42.28,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-101",
    cx: 403.42,
    cy: 358.39,
    rx: 38.42,
    ry: 21.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-101",
    cx: 104.34,
    cy: 365.87,
    rx: 72.73,
    ry: 40.27,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.07,363.19c-10.29-10.49-16.33-53.22-6.3-61.55h51.06c10,8.33,4,51-6.28,61.54l-.28.29-.36.35c-.29.28-.6.56-.93.83l-.24.19-.78.59a14.85,14.85,0,0,1-1.33.85c-8.46,4.88-22.19,4.88-30.65,0h0c-.45-.26-.9-.55-1.34-.86-.25-.18-.49-.36-.72-.55l-.31-.24c-.31-.26-.61-.52-.89-.79l-.41-.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.4,298.29c11.65,6.73,11.65,17.63,0,24.36s-30.54,6.73-42.19,0-11.65-17.63,0-24.36S412.75,291.56,424.4,298.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.8,301.53c8.55,4.94,8.55,12.94,0,17.88s-22.43,4.94-31,0-8.55-12.94,0-17.88S410.24,296.59,418.8,301.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.81,310c8.56-4.94,22.43-4.94,31,0a14.19,14.19,0,0,1,5.12,4.69,14.13,14.13,0,0,1-5.12,4.7c-8.56,4.94-22.43,4.94-31,0a14.21,14.21,0,0,1-5.12-4.7A14.28,14.28,0,0,1,387.81,310Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.28,296.52,401,291.31s-6-31.47-.81-45,14.72-13.48,19.27-9.85,2.06,15,.2,21.56c-2.25,7.91-9.4,43.35-4.36,55.92Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.28,296.52,401,291.31s-6-31.47-.81-45,14.72-13.48,19.27-9.85,2.06,15,.2,21.56c-2.25,7.91-9.4,43.35-4.36,55.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M406.82,292.86a.62.62,0,0,0,.37-.7c-5.94-26.91,6.32-51.92,6.44-52.17a.61.61,0,0,0-1.09-.55c-.13.25-12.58,25.64-6.55,53a.62.62,0,0,0,.73.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.14,288.33s-.82-2.47,2.82-3.1,5-3.66,5.38-8.74,1.88-8.72,6.44-9.47,8.24,1.55,11.21-.74,10.64-7.81,17-5.29,4.29,8,1,11.5-4.28,4.73-1.74,10.48.69,11.12-5.18,12.47-9.16.65-9.25,7.1c-.09,5.76-1.26,11.15-7.27,13.33a30.34,30.34,0,0,1-14.87,1.47,8.2,8.2,0,0,1-4.57-1.9c-1.22-1.23-1-2.6-1-4.2V288.33Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.14,288.33s-.82-2.47,2.82-3.1,5-3.66,5.38-8.74,1.88-8.72,6.44-9.47,8.24,1.55,11.21-.74,10.64-7.81,17-5.29,4.29,8,1,11.5-4.28,4.73-1.74,10.48.69,11.12-5.18,12.47-9.16.65-9.25,7.1c-.09,5.76-1.26,11.15-7.27,13.33a30.34,30.34,0,0,1-14.87,1.47,8.2,8.2,0,0,1-4.57-1.9c-1.22-1.23-1-2.6-1-4.2V288.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M405.14,314.89a.5.5,0,0,0,.48-.35c10.69-31.75,34.9-44.58,35.14-44.7a.51.51,0,0,0,.22-.68.5.5,0,0,0-.68-.22c-.25.13-24.81,13.12-35.64,45.28a.5.5,0,0,0,.32.64A.41.41,0,0,0,405.14,314.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.48,287.21l.11,0c7-1.59,18.16-.73,18.27-.72a.51.51,0,0,0,.55-.46.51.51,0,0,0-.47-.55c-.46,0-11.44-.88-18.57.75a.51.51,0,0,0,.11,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,302.47c3.19,0,6.57-.21,6.79-.22a.5.5,0,0,0,.47-.54.49.49,0,0,0-.54-.47c-.07,0-7.87.48-10.92,0a.52.52,0,0,0-.58.42.51.51,0,0,0,.42.58A31.36,31.36,0,0,0,414.79,302.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.76,283.48h0a.5.5,0,0,0,.47-.54A38.92,38.92,0,0,0,422,272.31a.52.52,0,0,0-.66-.29.5.5,0,0,0-.28.66A38.78,38.78,0,0,1,423.26,283,.5.5,0,0,0,423.76,283.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,318.33a30.15,30.15,0,0,1-15.52.57c-8.9-1.91-11.05-7.35-11.05-7.35s6.34-6.59,11.95-7a50.07,50.07,0,0,0-16.86.36s-5.15-1.9-4.18-10.51c0,0,4.85-3.53,16-2.15,0,0-5.59-3.94-15.4-5.11-.77,0,.28-11.2,1.21-16.2s2.79-4.22,6.8-3.79,16.63,4.6,18.13,7.47,0,10.16,0,10.16,3.67-3,4.48-6.68a13.94,13.94,0,0,1,7.66,3.17c3.53,3,2.51,4.89,1.36,7.86a33.57,33.57,0,0,1-4.63,8.38s3.76-1.36,7.33-10.32c0,0,3.69,6.86,4.34,11.77S412.61,314.32,405,318.33Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.77,318.8a.51.51,0,0,1-.33-.43c-1.34-16.67-20.21-42.72-28.55-47.95a.51.51,0,0,1-.16-.7.53.53,0,0,1,.7-.16c8.48,5.32,27.65,31.79,29,48.73a.5.5,0,0,1-.46.54A.4.4,0,0,1,404.77,318.8Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105,401.51a1.53,1.53,0,0,1-1.53-1.53V301.67a1.53,1.53,0,0,1,3.06,0V400A1.53,1.53,0,0,1,105,401.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8,365.73a1.53,1.53,0,0,1-1.42-1l-30.14-76.3a1.53,1.53,0,0,1,2.84-1.12l30.14,76.3a1.52,1.52,0,0,1-.86,2A1.55,1.55,0,0,1,165.8,365.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.18,356.56a1.51,1.51,0,0,1-1.11-.48L105,296.73l-56,59.1a1.53,1.53,0,1,1-2.22-2.1l57.1-60.28A1.55,1.55,0,0,1,105,293h0a1.55,1.55,0,0,1,1.11.48L163.29,354a1.53,1.53,0,0,1-1.11,2.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.16,365.73a1.55,1.55,0,0,1-.56-.11,1.52,1.52,0,0,1-.86-2l30.14-76.3a1.53,1.53,0,0,1,2.85,1.12l-30.15,76.3A1.53,1.53,0,0,1,44.16,365.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72,354.21l4,10.51a1.24,1.24,0,0,1,0,.27.61.61,0,0,1,0,.19,1.21,1.21,0,0,1-.6.67,2.71,2.71,0,0,1-2.42,0,1.05,1.05,0,0,1-.47-.5s0,0,0,0l0-.14-3.69-9.86Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.24,354.21l-4,10.51a1.24,1.24,0,0,0,0,.27.61.61,0,0,0,0,.19,1.21,1.21,0,0,0,.6.67,2.71,2.71,0,0,0,2.42,0,1.05,1.05,0,0,0,.47-.5s0,0,0,0l0-.14,3.7-9.86Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.74,392.37v8.7a.88.88,0,0,1-.51.72,2.82,2.82,0,0,1-2.5,0,.88.88,0,0,1-.51-.72v-8.7A3.72,3.72,0,0,1,106.74,392.37Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.66,287.34c0-2.51-2.2-5.19-6.85-8.2-8.59-5.58-27.79-16.77-39.81-23.43a.14.14,0,0,0-.1-.1C111.64,250,103,223.26,96.61,202.93c-2.18-6.92-4.86-10.84-8-12.68-.75-.44-3.52-2-4.14-2.34-6.28-3.76-14.53.76-24.8,6.38-9.47,5.18-16.86,11.81-18.35,29.4-.9,10.72,0,31.19,2.14,46.7h0c3.15,25.91,7,26,12.63,30.29,9.66,7.47,31.42,18,40.59,21.57,16.63,6.54,30.22-3.55,40.35-8.55a236.08,236.08,0,0,0,26.85-15.9c2.53-1.85,3.85-3.71,3.82-5.67C167.65,291.34,167.67,288.15,167.66,287.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,308.87A236.78,236.78,0,0,0,163.84,293c5.76-4.18,5.23-8.46-3-13.82-6.16-4-5.84-4.35-52.23-29.85,0,0-59.15,34.9-56.6,41.35s33.13,22.24,44.66,26.78C113.27,324,126.86,313.87,137,308.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.22,190c-6.23-3.27-14.32,1.17-24.33,6.65-6.41,3.52-11.87,7.68-15.19,15.47l-4.22-2.44c3.31-7.76,8.77-11.92,15.16-15.43,10.27-5.62,18.52-10.14,24.8-6.38C85,188.23,87.18,189.45,88.22,190Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.89,196.7c15.37-8.42,26.22-14.4,32.72,6.23,6.4,20.33,15,47.07,24.29,52.68,0,0-3-2.54-26,14.85-7.32,5.53-16.21,10.07-22,13.55-11.43,6.81-18.37,9.54-19.46,8.63-6.05-5-9.32-48.95-7.83-66.54S54.43,201.88,63.89,196.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.89,196.7c15.37-8.42,26.22-14.4,32.72,6.23,6.4,20.33,15,47.07,24.29,52.68,0,0-15.87,0-38.87,12.41-23.9,12.91-27.56,25.53-28.65,24.62-6.05-5-9.32-48.95-7.83-66.54S54.43,201.88,63.89,196.7Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.26,147.4c4.07-.91,7.66-1.76,10.42-2.47,14.68-3.75,19.1-8.61,19.55-15.1.73-10.36-3.15-10.44-9.84-5.81a36.28,36.28,0,0,1-9.05,4.67,18,18,0,0,0,2.77-4.25c1-2.58-.36-4.23-1.25-4.67-.7-.34-1.41,1.45-3.83,3.43-3.12,2.53-5.64,3-8.22,6.53a6.85,6.85,0,0,1-4,2.55c-1.46.33-25.43,6.89-36.66,8.82-6.59-8.39-12.71-17.34-19.68-26.25-10.73-13.74-15.83-15.66-21.85-14.57l-5.23,17.24s35.34,41.62,35.76,42.14a9.6,9.6,0,0,0,10.71,3.41C333.08,158.6,349.19,151.59,358.26,147.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.22,96.81c12.54.55,16.26,7.58,22.7,15.38S318.38,140,318.38,140l34.23-7.16s-1.41,9.83,3,15.75c0,0-18.16,9.16-29.16,13.37-13.9,5.34-14.81,4.12-17.32,1.82s-33-36.81-33-36.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72,120c3.25-9.86,6.84-10.27,11.27-3.45a36.63,36.63,0,0,0,6.6,7.76,18.31,18.31,0,0,1-1-5c0-2.77,1.94-3.79,2.93-3.85.78,0,.75,1.87,2.25,4.62,1.92,3.53,4.07,4.93,5.13,9.16.4,1.59,1.44,4.75,2.77,5.69,6.8,4.78,19.16,10.67,31.45,15.42,4.36-9.21,10.11-20.7,14.49-28.75,8.34-15.3,13.86-17,19.93-16.28l6.18,16.91s-33,43.53-33.34,44.07c-2.53,3.56-7.71,6-11.74,4.35-11.51-4.72-20.06-13-29.83-19.66-5.8-3.94-11.28-7-14.78-9.62C133.92,132.35,131.68,126.18,133.72,120Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.61,310.29c.27-13,4.18-22.65,4.49-26.26,0,0-1-77.33-1-89.88l65.94-2.69s-.92,77.53-.92,88.28-1.61,56.44-3.31,77.47h0l-.19,6.92-14.72,4.58s.28-2,0-11.84-6.89-43.82-7.51-52.45c-.79-11.17,1-15.68.77-23.14S260.58,225,260.58,225s-8.26,48-10.32,64.25c-2.35,18.66-9.91,67.57-9.93,78.94,0,2,0,4.4,0,6.95,0,6.16-.17,7.78.82,10.16,1.72,4.16-13,6.78-13.7,3.82l-1.59-12.22v-.35h0v-7.75C225.88,357.21,221.21,329.15,221.61,310.29Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.45,383.43a4.93,4.93,0,0,1-.2,3.64c-.51,1.07-6.07,4.21-13.58,3.7a31.31,31.31,0,0,1-15.52-5.42c-2.86-1.9-5.84-2.25-9.56-2.47s-8.6-2.06-9.41-3.8.12-4.73.12-4.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.16,360l.6-.13a2.36,2.36,0,0,1,1-.05,1.93,1.93,0,0,1,.92.63,17.69,17.69,0,0,1,1.92,3c1.57,2.56,4.88,4.69,8.48,6.63,2.46,1.32,4.86,2.34,7.39,3.48s6,1.87,8,3.23c2.95,2,3.33,7,0,8.94-2.89,1.7-10.51,3.54-18.5,1.28-4.35-1.23-9.18-5.88-14.89-6.33-3.64-.28-10.51-1.3-12.85-4.06-.86-1.23.29-5.11,1.24-8.45,1-3.66,2.27-9.38,3.48-9.06.05.72-.09.9.38,1.39s1.05.75,1.54,1.17a9.61,9.61,0,0,1,2,2.89,2.17,2.17,0,0,0,1,1.12c.62.23,1.07-.16,1.61-.4a3.12,3.12,0,0,1,2.17-.16,14.11,14.11,0,0,0-.38-2.14,1.27,1.27,0,0,1-.06-.69,1.15,1.15,0,0,1,.47-.53A11.56,11.56,0,0,1,285.16,360Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.47,404.7c.44.42.31,3.28-.18,4s-3.55,3.4-9,3.8c-5.21.37-9.87-.33-12.93-2.28s-4.55-4.09-4.83-7.06,0-5.84-1.38-8.12c-1.31-2.11-3.39-4.49-3.84-5.64-1-2.49,0-6.05,0-6.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.19,378.76a11.65,11.65,0,0,0,.6,3.31,30.72,30.72,0,0,0,3.2,6.54,26.06,26.06,0,0,0,2.17,3.06c1.58,1.88,3.54,3.42,5.21,5.22a10.68,10.68,0,0,1,3.22,6.41c.22,4.09-4.22,5.48-7.64,6.08a25.13,25.13,0,0,1-11.11-.55,10.22,10.22,0,0,1-7.48-8.15c-.19-1.14-.12-2.3-.25-3.44a16.17,16.17,0,0,0-3.18-7.16,21.19,21.19,0,0,1-2.44-3.9c-1.07-2.53-.22-5.38.47-7.9.59-2.18,1.25-4.64,2-4.44,0,1.13,0,1.25.81,2,1,1,1.06,2.43,2.15,3.28a14.64,14.64,0,0,1-.76-2.91,1.59,1.59,0,0,1,.23-1.15,2.94,2.94,0,0,1,1.25-.67,24.19,24.19,0,0,1,5-1.13,14.9,14.9,0,0,1,4.85,0,2.11,2.11,0,0,1,1.22.71,2.42,2.42,0,0,1,.43,1.39C241.21,376,241.16,377.68,241.19,378.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54,389.46c-1.53-1.14-4.94-1.15-6.81-.95a11.32,11.32,0,0,0-5.3,1.86,1.21,1.21,0,0,1-1.56-.12h0a1.14,1.14,0,0,1,.11-1.74,11.45,11.45,0,0,1,6-2.21c4.6-.33,5.94.46,5.94.46S246,388.11,245.54,389.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,393.65c-1.92-1.13-5.67-1-7.54-.76a10.7,10.7,0,0,0-5.16,2,1.2,1.2,0,0,1-1.56-.13h0a1.13,1.13,0,0,1,.12-1.73,11.9,11.9,0,0,1,6.1-2.39c4.59-.33,5.79.61,5.79.61A3.81,3.81,0,0,1,249,393.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,381.9a11.49,11.49,0,0,1,5.78.48c.81.46,1.34,1.74.82,2.06a10.57,10.57,0,0,0-5.12-.7,15.16,15.16,0,0,0-5,1.36c-.39.18-.85.42-1.26.65a1.1,1.1,0,0,1-1.51-.47h0a1,1,0,0,1,.4-1.32A14.66,14.66,0,0,1,236.12,381.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.68,368.12a3.36,3.36,0,0,0-2.68-1.79c-1.65-.31-4.57.91-6.39,2.4a1.36,1.36,0,0,0,.2,2.24h0a1.36,1.36,0,0,0,1.55-.17A10.32,10.32,0,0,1,294.68,368.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,371a3.86,3.86,0,0,0-3.17-1.64s-4.32.13-7,2.62a1.32,1.32,0,0,0,.18,2.16h0a1.28,1.28,0,0,0,1.49-.17A10.38,10.38,0,0,1,299.8,371Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.46,373.58a4.31,4.31,0,0,0-3.3-1.48,11.61,11.61,0,0,0-6.69,2.64,1.32,1.32,0,0,0,.18,2.16h0a1.29,1.29,0,0,0,1.49-.17A9.88,9.88,0,0,1,305.46,373.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.08,191.46s.88,54.63,1,64.23,0,28,0,37.38c0,0-2.43,4.1-16.29,4.09s-15.86-3.84-15.86-3.84l-2.05-44.16L254,295a24.84,24.84,0,0,1-19.37,3.71c-11.41-2.46-13.09-5.86-13.09-5.86l2.25-101.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,249.16l2-18.54s9.51-2.32,15.87-7.11a29.79,29.79,0,0,1-7.22,6.33c-3.86,2.17-5.72,3.06-5.72,3.06l-2.78,17.94-.49,35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,200.93c9.05,6.59,50.08,13.9,69.12,0,0,0-.44-53.18-1.94-81.33-.07-1.28-.15-2.52-.28-3.72,0-.4-.1-.8-.14-1.2a37.68,37.68,0,0,0-1-5c-.07-.27-.16-.54-.24-.81-.19-.61-.38-1.2-.63-1.79-.12-.31-.25-.62-.39-.92s-.26-.57-.42-.84a.41.41,0,0,0-.07-.15c-.14-.27-.3-.54-.45-.8s-.34-.57-.54-.85-.37-.53-.56-.77-.44-.54-.68-.8a9.35,9.35,0,0,0-.69-.72l-.5-.47-.5-.41c-.21-.19-.45-.36-.68-.53a18.07,18.07,0,0,0-2.4-1.42c-.23-.11-.47-.23-.71-.32a1.38,1.38,0,0,1-.17-.08l-.86-.32a14.89,14.89,0,0,0-1.47-.49q-.76-.21-1.59-.39c-.62,0-1.3,0-2,0l-1.5,0-1.62.06c-7.12.31-17.34,1.46-25.54,2.51l-1.6.22-1.41.17c-5.63.74-9.8,1.35-10.44,1.45H231c-1.84.47-3.55.91-4.93,1.32-3.76,1.11-1,.16-1.79,3.8-2.43,10.68.4,49.53.4,49.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.37,67.59s2.93,13.75,4.1,16a6.25,6.25,0,0,0,3.6,2.9l-.21-9.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,47.9a6.76,6.76,0,0,0-5.6,2C235,52.34,236.37,60,239.37,67.59l5.51.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.53,68.23c-1.1.66-2.68-1.46-4-2.89s-5.81-3.37-8,1.3,2,11.06,5.46,12.16c6,1.9,6.94-2,6.94-2L247.27,99c6.32,11.45,27.71,5.59,19.69-2l0-5.63a64.3,64.3,0,0,0,9.11,0c4.44-.69,6.26-3.76,7.61-8.57,2.16-7.72,3-13.95,1.15-29.13-2-16.63-21.36-16.8-31.81-10.23S246.53,68.23,246.53,68.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,38.81a53.88,53.88,0,0,1,11.41-3.44c8.44-1.83,17-3.52,24.74-7.41a5.41,5.41,0,0,1,3-.87c2,.27,2.92,2.73,3,4.77a17,17,0,0,1-.74,5.62,3.23,3.23,0,0,1,4.54.07,5.61,5.61,0,0,1,1.32,4.74c-.5,3.78-3.39,6.93-6.82,8.61s-7.31,2.09-11.12,2.2a76.21,76.21,0,0,1-15.89-1.19,11.17,11.17,0,0,0-3.85-.28,3.45,3.45,0,0,0-2.87,2.28c-.56,2.1-1.15,16.39-4.08,16.45-.55,0-2.63-3.59-4-4.87-1.7-1.62-3.42-13.86-3.72-16.12a1.13,1.13,0,0,0-.23-.48c-1.92-2.69.33-7.22,2.7-8.7A25.4,25.4,0,0,1,244,38.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.74,49.08a4,4,0,1,1-6.13-5.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.94,91.39s-9.9-1-13.37-2.8a11.39,11.39,0,0,1-4.79-4.74,15.65,15.65,0,0,0,2.72,5.59c2.54,3.24,15.44,5.63,15.44,5.63Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.56,65.75a2,2,0,1,1-2-2.07A2,2,0,0,1,264.56,65.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.46,58.26l-4.25,2.34a2.54,2.54,0,0,1,1-3.38A2.36,2.36,0,0,1,262.46,58.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.05,79.47l4.53,1.7a2.38,2.38,0,0,1-3.08,1.5A2.53,2.53,0,0,1,266.05,79.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.27,59.91l-3.87-3a2.34,2.34,0,0,1,3.36-.52A2.57,2.57,0,0,1,282.27,59.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,65.19a2,2,0,1,1-2-2.07A2,2,0,0,1,281.08,65.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.6 63.77 273.26 75.71 279.49 73.58 272.6 63.77",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75,101.2c-14.65.23-18.45,8.86-22.77,18S193.7,149,193.7,149l-27.58-12.47a21.7,21.7,0,0,1-9.27,11.83s13,10.93,24.22,18.94c9.49,6.78,15,10.3,18.65,7.87,2.7-1.8,29.62-37,29.62-37C236.2,127.47,237.66,109.3,231.75,101.2Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.4,70.59s-1.57-.8-1.57-.8l-1.54-2.2a1.71,1.71,0,0,1,1.55.11C277.54,68.2,278.4,70.59,278.4,70.59Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.4,70.59s-1.57-.8-1.57-.8l-1.54-2.2a1.71,1.71,0,0,1,1.55.11C277.54,68.2,278.4,70.59,278.4,70.59Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,63.72a7.5,7.5,0,0,1-5.89,6.88l-2.47.42a16,16,0,0,1-3.28.26h-.33c-.18,0-.36,0-.53,0a6.91,6.91,0,0,1-.91-.15,2.78,2.78,0,0,1-.46-.13,2.09,2.09,0,0,1-.4-.16.51.51,0,0,1-.16-.09,1,1,0,0,1-.19-.12,1.11,1.11,0,0,1-.25-.3l-.85-1.74a2,2,0,0,0-2-1l-1.76.31a3.06,3.06,0,0,0-2,1.67s-.37.92-.84,2-3.39,2.49-6.51,3l-2.47.44a5.16,5.16,0,0,1-1.51,0,3.8,3.8,0,0,1-.83-.15l-.38-.11-.24-.1a3.59,3.59,0,0,1-.62-.31c-.67-.27-11.44-4.65-12.92-8.18-2.36-5.68,7.33-11.53,10.82-12.64h0a6.25,6.25,0,0,1,1.24-.36L282.7,48.8a5,5,0,0,1,3.67.69c.65.41,3.05,1.83,4.05,2.43a1.28,1.28,0,0,1,.25.15c.14.08.28.18.42.27a.75.75,0,0,1,.13.11c.14.11.27.23.4.35a4.15,4.15,0,0,1,.43.51,2.48,2.48,0,0,1,.26.4,4.05,4.05,0,0,1,.32.62c.08.19.14.38.2.57v0a3.15,3.15,0,0,1,.11.55.31.31,0,0,1,0,.13,4.34,4.34,0,0,1,0,.63Q293.11,60,293,63.72Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293,63.72a7.5,7.5,0,0,1-5.89,6.88l-2.47.42a16,16,0,0,1-3.28.26h-.33c-.18,0-.36,0-.53,0a6.91,6.91,0,0,1-.91-.15,2.78,2.78,0,0,1-.46-.13,2.09,2.09,0,0,1-.4-.16.51.51,0,0,1-.16-.09,1,1,0,0,1-.19-.12,1.11,1.11,0,0,1-.25-.3l-.85-1.74a2,2,0,0,0-2-1l-1.76.31a3.06,3.06,0,0,0-2,1.67s-.37.92-.84,2-3.39,2.49-6.51,3l-2.47.44a5.16,5.16,0,0,1-1.51,0,3.8,3.8,0,0,1-.83-.15l-.38-.11-.24-.1a3.59,3.59,0,0,1-.62-.31c-.67-.27-11.44-4.65-12.92-8.18-2.36-5.68,7.33-11.53,10.82-12.64h0a6.25,6.25,0,0,1,1.24-.36L282.7,48.8a5,5,0,0,1,3.67.69c.65.41,3.05,1.83,4.05,2.43a1.28,1.28,0,0,1,.25.15c.14.08.28.18.42.27a.75.75,0,0,1,.13.11c.14.11.27.23.4.35a4.15,4.15,0,0,1,.43.51,2.48,2.48,0,0,1,.26.4,4.05,4.05,0,0,1,.32.62c.08.19.14.38.2.57v0a3.15,3.15,0,0,1,.11.55.31.31,0,0,1,0,.13,4.34,4.34,0,0,1,0,.63Q293.11,60,293,63.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M290.42,51.92a5.12,5.12,0,0,0-3.29-.48l-25.44,4.49a7.52,7.52,0,0,0-5.87,6.44l-7.3-4.21A24.59,24.59,0,0,1,256,53.64h0a6.25,6.25,0,0,1,1.24-.36L282.7,48.8a5,5,0,0,1,3.67.69C287,49.9,289.42,51.32,290.42,51.92Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.42,51.92a5.12,5.12,0,0,0-3.29-.48l-25.44,4.49a7.52,7.52,0,0,0-5.87,6.44l-7.3-4.21A24.59,24.59,0,0,1,256,53.64h0a6.25,6.25,0,0,1,1.24-.36L282.7,48.8a5,5,0,0,1,3.67.69C287,49.9,289.42,51.32,290.42,51.92Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,56.23q.09,3.74,0,7.5a7.47,7.47,0,0,1-5.89,6.86l-2.47.44c-3.13.55-6,.21-6.51-.74l-.85-1.74a2,2,0,0,0-2-1l-1.77.32a3,3,0,0,0-2,1.67l-.85,2c-.47,1.12-3.38,2.48-6.5,3l-2.47.44a4.88,4.88,0,0,1-5.9-4.79c-.06-2.49-.06-5,0-7.49a7.49,7.49,0,0,1,5.9-6.87l25.44-4.48A4.87,4.87,0,0,1,293,56.23Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,63.72a7.5,7.5,0,0,1-5.89,6.88l-2.47.42a16,16,0,0,1-3.28.26h-.33c-.18,0-.36,0-.53,0a6.91,6.91,0,0,1-.91-.15,2.78,2.78,0,0,1-.46-.13,2.09,2.09,0,0,1-.4-.16.51.51,0,0,1-.16-.09,1,1,0,0,1-.19-.12,1.11,1.11,0,0,1-.25-.3l-.85-1.74a2,2,0,0,0-2-1l-1.76.31a3.06,3.06,0,0,0-2,1.67s-.37.92-.84,2-3.39,2.49-6.51,3l-2.47.44a5.16,5.16,0,0,1-1.51,0,3.8,3.8,0,0,1-.83-.15l-.38-.11-.24-.1a3.59,3.59,0,0,1-.62-.31,4.88,4.88,0,0,1-2.32-4.16c-.06-2.5-.06-5,0-7.5a7.49,7.49,0,0,1,5.9-6.87l25.44-4.49a5.12,5.12,0,0,1,3.29.48,1.28,1.28,0,0,1,.25.15c.14.08.28.18.42.27a.75.75,0,0,1,.13.11c.14.11.27.23.4.35a4.15,4.15,0,0,1,.43.51,2.48,2.48,0,0,1,.26.4,4.05,4.05,0,0,1,.32.62c.08.19.14.38.2.57v0a3.15,3.15,0,0,1,.11.55.31.31,0,0,1,0,.13,4.34,4.34,0,0,1,0,.63Q293.11,60,293,63.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293,56.23a4.34,4.34,0,0,0,0-.63.31.31,0,0,0,0-.13,3.15,3.15,0,0,0-.11-.55v0c-.06-.19-.12-.38-.2-.57a4.05,4.05,0,0,0-.32-.62,2.48,2.48,0,0,0-.26-.4,4.15,4.15,0,0,0-.43-.51c-.13-.12-.26-.24-.4-.35a.58.58,0,0,0-.12-.1L275.87,67.58a1.91,1.91,0,0,1,1.43,1l.85,1.74a1.11,1.11,0,0,0,.25.3,1,1,0,0,0,.19.12.51.51,0,0,0,.16.09,2.09,2.09,0,0,0,.4.16,2.78,2.78,0,0,0,.46.13,6.91,6.91,0,0,0,.91.15c.17,0,.35,0,.53,0h.33a15,15,0,0,0,2-.09l9.7-9.69C293.07,59.74,293.06,58,293,56.23Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.94,52.54,258.71,74.76h0l.24.1.38.11a3.8,3.8,0,0,0,.83.15,5.16,5.16,0,0,0,1.51,0l1.61-.29,23.25-23.24Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,55.32l-9.35,9.36c0,1.87,0,3.74,0,5.62a5.13,5.13,0,0,0,.66,2.45l19.3-19.3Z",
    style: {
      fill: "#1BD950"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,65.14a.9.9,0,0,1-1,1,1.31,1.31,0,0,1-1-1.3.9.9,0,0,1,1-1A1.32,1.32,0,0,1,249.9,65.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.1,51.89h0a4.56,4.56,0,0,1,2.08.5,1.35,1.35,0,0,1,.21.13,4.18,4.18,0,0,1,.38.25l.05,0,0,0,.05,0,.35.31a3.6,3.6,0,0,1,.39.47,1.77,1.77,0,0,1,.21.32v0l0,0a4.39,4.39,0,0,1,.27.53,3.76,3.76,0,0,1,.15.44v0l0,.08a2,2,0,0,1,.09.45v.15a3.69,3.69,0,0,1,0,.56c.07,2.48.07,5,0,7.47A7,7,0,0,1,287,70.07l-2.47.43a17.08,17.08,0,0,1-2.78.25h-.43l-.31,0h-.48a7.07,7.07,0,0,1-.86-.15,3.74,3.74,0,0,1-.42-.11,1.81,1.81,0,0,1-.28-.12l-.07,0h0l0,0,0,0-.1-.06a.7.7,0,0,1-.12-.14l-.85-1.74A2.49,2.49,0,0,0,275.59,67a2.56,2.56,0,0,0-.39,0l-1.77.31a3.59,3.59,0,0,0-2.41,2l-.85,2c-.35.83-2.94,2.15-6.11,2.71l-2.46.43a5.64,5.64,0,0,1-.88.08,4.19,4.19,0,0,1-.5,0,4.44,4.44,0,0,1-.74-.13l-.3-.1-.13-.05-.12,0a2.73,2.73,0,0,1-.54-.27,4.35,4.35,0,0,1-2.07-3.72c-.05-2.47-.05-5,0-7.47a7,7,0,0,1,5.46-6.35L287.23,52a5.12,5.12,0,0,1,.87-.08m0-.53a6.45,6.45,0,0,0-1,.08l-25.44,4.49a7.49,7.49,0,0,0-5.9,6.87c-.06,2.51-.06,5,0,7.5a4.88,4.88,0,0,0,2.32,4.16,3.59,3.59,0,0,0,.62.31l.24.1.38.11a3.8,3.8,0,0,0,.83.15,4.63,4.63,0,0,0,.54,0,5.51,5.51,0,0,0,1-.08l2.47-.44c3.12-.54,6-1.9,6.51-3s.84-2,.84-2a3.06,3.06,0,0,1,2-1.67l1.76-.31a1.53,1.53,0,0,1,.3,0,2,2,0,0,1,1.71,1l.85,1.74a1.11,1.11,0,0,0,.25.3,1,1,0,0,0,.19.12.51.51,0,0,0,.16.09,2.09,2.09,0,0,0,.4.16,2.78,2.78,0,0,0,.46.13,6.91,6.91,0,0,0,.91.15c.17,0,.35,0,.53,0h.74a16.41,16.41,0,0,0,2.87-.27l2.47-.42A7.5,7.5,0,0,0,293,63.72q.09-3.75,0-7.49a4.34,4.34,0,0,0,0-.63.31.31,0,0,0,0-.13,3.15,3.15,0,0,0-.11-.55v0c-.06-.19-.12-.38-.2-.57a4.05,4.05,0,0,0-.32-.62,2.48,2.48,0,0,0-.26-.4,4.15,4.15,0,0,0-.43-.51c-.13-.12-.26-.24-.4-.35a.75.75,0,0,0-.13-.11c-.14-.09-.28-.19-.42-.27a1.28,1.28,0,0,0-.25-.15,5,5,0,0,0-2.32-.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M255.79,70.3l-.13-5.39c0-.9-.07-1.78,0-2.71a7.13,7.13,0,0,1,.84-2.62A7.76,7.76,0,0,1,260.56,56a17.3,17.3,0,0,1,2.67-.59l2.65-.48,10.61-1.81q5.31-.88,10.64-1.67-5.28,1.08-10.57,2.08L266,55.45l-2.65.45a17.2,17.2,0,0,0-2.59.54,7.59,7.59,0,0,0-3.88,3.34,6.8,6.8,0,0,0-.85,2.46c-.1.86-.05,1.78-.08,2.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-101"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.1,27.08V156.54c-2.22,13.55-9.19,26.86-21,39.08a118.16,118.16,0,0,1-13.74,12.1,158.23,158.23,0,0,1-14.88,9.75c-19.58,11.34-42.77,19.32-67.41,24q-5.88,1.13-11.88,2v-130c27.7-4.48,53.8-12.73,75.66-24.76,27.13-15,43.68-33.51,49.68-52.87,0,0,0,0,0,0a62.6,62.6,0,0,0,2.77-8.8A.42.42,0,0,1,436.1,27.08Z",
    style: {
      fill: "#1BD950"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.62,244.09V113l.45-.07c28.34-4.58,54.44-13.12,75.48-24.7,26.11-14.38,43.2-32.53,49.4-52.48v-.45h.18a63.76,63.76,0,0,0,2.62-8.4,1,1,0,0,1,1.88.22V156.54c-2.29,14.07-9.42,27.32-21.18,39.45a117.76,117.76,0,0,1-13.81,12.15,156.15,156.15,0,0,1-14.94,9.79C367.56,229,344.82,237.12,319.13,242c-3.91.75-7.92,1.42-11.9,2Zm1.07-130.21v129c3.76-.55,7.54-1.19,11.24-1.89,25.57-4.87,48.2-12.93,67.24-24A159.76,159.76,0,0,0,401,207.29a118.25,118.25,0,0,0,13.68-12c11.61-12,18.64-25,20.89-38.8V28.05A65.74,65.74,0,0,1,433,36v0c-6.29,20.23-23.55,38.6-49.93,53.12C362,100.71,336,109.27,307.69,113.88Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.21,211.19a1.07,1.07,0,0,1-1.07-1.07V133.66a1.08,1.08,0,0,1,.79-1c6.33-1.7,12.17-3.51,17.85-5.55a1.05,1.05,0,0,1,1,.13,1.07,1.07,0,0,1,.46.88v76.46a1.08,1.08,0,0,1-.71,1c-5.75,2.06-11.64,3.89-18,5.6A1.33,1.33,0,0,1,337.21,211.19Zm1.07-76.71v74.24c5.54-1.51,10.73-3.13,15.79-4.93V129.6C349,131.37,343.84,133,338.28,134.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61,198.9a1,1,0,0,1-.58-.17,1.06,1.06,0,0,1-.49-.9V121.37a1.09,1.09,0,0,1,.63-1,158.33,158.33,0,0,0,14.73-7.55c1.09-.58,2.1-1.2,3.07-1.81a1,1,0,0,1,1.08,0,1.06,1.06,0,0,1,.56.93v76.46a1.06,1.06,0,0,1-.51.91c-1,.63-2.05,1.29-3.17,1.88A159.19,159.19,0,0,1,372,198.81,1.07,1.07,0,0,1,371.61,198.9Zm1.07-76.83v74.11c4.18-1.93,8.52-4.18,13.22-6.88.9-.47,1.74-1,2.57-1.5v-74c-.5.3-1,.59-1.54.87C381.88,117.62,377.2,120,372.68,122.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.94,177.87a1,1,0,0,1-.45-.1,1.07,1.07,0,0,1-.62-1V100.34a1.07,1.07,0,0,1,.39-.82,114,114,0,0,0,9-8.29A82.53,82.53,0,0,0,423,80.79a1.07,1.07,0,0,1,1.95.61v76.46a1.13,1.13,0,0,1-.19.62,86.16,86.16,0,0,1-8.92,10.71,118.14,118.14,0,0,1-9.2,8.44A1.09,1.09,0,0,1,405.94,177.87Zm1.07-77V174.5c2.6-2.23,5.05-4.51,7.29-6.81a83.44,83.44,0,0,0,8.5-10.17V84.68a86.11,86.11,0,0,1-7,8A114,114,0,0,1,407,100.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.11,224.45l43.49-80.34,34.78,45.19S383.72,210.28,320.11,224.45Z",
    style: {
      fill: "#1BD950"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.33,229.28C199.62,227.16,161,217.73,130.55,201c-34.22-18.85-51.63-43.45-52.21-68.14v-2.46L78,47.18c0-5.94,10.46,10.9,32.37,28.17.52.42,1,.81,1.57,1.22,1.22.94,2.47,1.86,3.77,2.78a151.89,151.89,0,0,0,14.92,9.32C161,105.36,199.44,114.78,239,116.93Z",
    style: {
      fill: "#1BD950"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.14,46.73h0m0,.57a64.2,64.2,0,0,1,6.23,6.12,225,225,0,0,0,24.4,22.76c.38.31.77.61,1.17.91l.41.33c1.17.9,2.41,1.82,3.81,2.81a155.6,155.6,0,0,0,15,9.37c29,16,67.2,26,107.79,28.34l.32,110.21c-40.4-2.31-78.42-12.27-107.18-28.1C98.35,182,80,158.15,79.41,132.84v-2.46L79.1,47.3M78.64,46c-.41,0-.61.39-.61,1.22l.31,83.2v2.46c.58,24.69,18,49.29,52.21,68.14,30.41,16.75,69.07,26.18,108.78,28.3L239,116.93c-39.55-2.15-78-11.57-108.33-28.26a151.89,151.89,0,0,1-14.92-9.32c-1.3-.92-2.55-1.84-3.77-2.78-.53-.41-1-.8-1.57-1.22C91.56,60.5,81.17,46,78.64,46Z",
    style: {
      fill: "#1BD950"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.93,213.32h-.14c-.33,0-32.5-4.66-63.8-20.55-35.86-18.2-49.94-46.41-50.08-46.7a1,1,0,0,1-.11-.47V124a1,1,0,0,1,.2-.61l23.51-33.24a1.1,1.1,0,0,1,1-.44,1.06,1.06,0,0,1,.87.64l29.17,68L139,145.81a1.08,1.08,0,0,1,.44-1.09L163,128.17a1,1,0,0,1,.84-.17,1.08,1.08,0,0,1,.7.5l37.36,62.76a1.08,1.08,0,0,1,.15.55v20.44a1.05,1.05,0,0,1-1.07,1.07Zm-112-68c1.36,2.61,15.47,28.49,49,45.52,27.55,14,55.77,19.14,61.9,20.14V192.1l-36.62-61.52-22,15.49,4.43,22a1.07,1.07,0,0,1-2,.63L111.16,93,88.94,124.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.52,150a10.7,10.7,0,0,1-2-.2c-6.45-1.26-11.69-8.32-11.69-15.73a12.15,12.15,0,0,1,4.07-9.53,9.49,9.49,0,0,1,8-2c6.44,1.26,11.68,8.32,11.68,15.73a12.13,12.13,0,0,1-4.07,9.53A9.34,9.34,0,0,1,200.52,150Zm-3.61-25.46a7.23,7.23,0,0,0-4.66,1.65,10.06,10.06,0,0,0-3.29,7.88c0,6.44,4.47,12.55,10,13.63a7.41,7.41,0,0,0,6.25-1.5,10.06,10.06,0,0,0,3.29-7.88c0-6.44-4.46-12.55-10-13.63A8.83,8.83,0,0,0,196.91,124.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.82,72.61s9.75,17.13,29.91,24.58V87.51C96.4,78.37,85.82,61.26,85.82,61.26Z",
    style: {
      fill: "#1BD950"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.82,90.15s9.75,17.13,29.91,24.58v-9.68C96.4,95.91,85.82,78.8,85.82,78.8Z",
    style: {
      fill: "#1BD950"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.82,107.69s9.75,17.13,29.91,24.58v-9.68C96.4,113.45,85.82,96.34,85.82,96.34Z",
    style: {
      fill: "#1BD950"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapaCads2);
export default __webpack_public_path__ + "static/media/capa-cads2.61e3e14d6fd656bf13c3e6ea4a27e4e8.svg";
export { ForwardRef as ReactComponent };